export const userActive = { 
    email: "ibr@edenlx.com",
    createDate: new Date(2026, 7, 1),
    subscription: {
        status: "trialing",
        amount: 4.99,
        plan: "annual",
        createdAt: 1773630178,
        currentPeriodEnd: 1776222178,
        currentPeriodStart: 1773630178,
        trialEnd: 1776222178,
        updatedAt: 1773630180,
        cancelAtPeriodEnd: false

    }
}
export const userTrialing = { 
    email: "ibr@edenlx.com",
    createDate: new Date(2026, 7, 1),
    subscription: {
        status: "trialing"
    }
}

export const userUnsubscribed = { 
    email: "ibr@edenlx.com",
    createDate: new Date(2026, 7, 1),
        subscription: {
        status: "canceled"
    }
}